import {
  FETCH_SUBSCRIPTION_INVOICE,
  UPDATE_SUBSCRIPTION_INVOICE,
} from '../constants';

const subscriptionInvoices = (state = [], action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_INVOICE:
      return action.payload;
    case UPDATE_SUBSCRIPTION_INVOICE:
      return state.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
    default:
      return state;
  }
};

export default subscriptionInvoices;

export const getSubscriptionInvoices = state => state.admin.subscriptions.subscriptionInvoices;
